import { Injectable } from '@angular/core';
import { DefaultResponse } from './default-response';
import { HttpService } from './http.services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BaseHttpService {
  constructor(public _http: HttpService) {}

  post<T>(
    url: string,
    body: any,
    useDefaultHeader = true,
    useFormData = false
  ): Observable<DefaultResponse<T>> {
    return this._http.post<T>(url, body, useDefaultHeader, useFormData);
  }

  postCustom<T>(
    url: string,
    body: any,
    useDefaultHeader = true,
    useFormData = false
  ): Observable<any> {
    return this._http.postCustom<T>(url, body, useDefaultHeader, useFormData);
  }

  put<T>(
    url: string,
    body: any,
    useDefaultHeader = true,
    useFormData = false
  ): Observable<DefaultResponse<T>> {
    return this._http.put<T>(url, body, useDefaultHeader, useFormData);
  }

  patch<T>(url: string, body: any): Observable<DefaultResponse<T>> {
    return this._http.patch<T>(url, body);
  }

  get<T>(url: string, id: number): Observable<DefaultResponse<T>> {
    return this._http.get<T>(`${url}/${id}`);
  }

  getCustom<T>(url: string): Observable<DefaultResponse<T>> {
    return this._http.get<T>(`${url}`);
  }

  getAll<T>(url: string): Observable<DefaultResponse<T>> {
    return this._http.get<T>(`${url}`);
  }

  getAllCustom<T>(url: string): Observable<any> {
    return this._http.getCustom<T>(url);
  }

  download(url: string): Observable<ArrayBuffer> {
    return this._http.download(`${url}`);
  }

  delete<T>(url: string, id: number): Observable<DefaultResponse<T>> {
    return this._http.delete<T>(url, id);
  }

  deleteCustom<T>(url: string, body: any): Observable<DefaultResponse<T>> {
    return this._http.deleteCustom<T>(url, body);
  }
}
